import React from 'react'
import { Button } from 'styles/algolia/button'
import { FilterIcon } from 'styles/algolia/icons'
import type { ConnectorProps as FilterConnectorProps } from '../../connectors/Filter'
import FilterConnector from '../../connectors/Filter'
export default FilterConnector(({ facetCount, filterEvent }: FilterConnectorProps) => (
  <Button onClick={filterEvent} data-type='filter'>
    <FilterIcon />
    <span>Filters {facetCount ? ` (${facetCount})` : ``}</span>
  </Button>
))